<template>
  <div class="w-full px-6 py-4">
    <!--<div class="mb-5 flex items-center">
      <o-icon icon="customerEdit" :size="20" class="text-blue-800 mr-3 opacity-75" />
      <div>
        <p class="leading-none mb-1 text-gray-700">
          Personal Information
        </p>
        <p class="leading-none text-sm text-gray-500 dark:text-gray-400">
          Name and contact details
        </p>
      </div>
    </div>-->
    <div>
      <div class="flex space-x-4 mb-8">
        <o-field-group class="w-full" :label="$t('general.name')">
          <text-field v-model="_resource.firstName" :label="$t('general.name')" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group
          v-slot="{ status }"
          :label="$t('general.enabled')"
          :name="$t('general.enabled')"
          :info="$t('components.resource.edit.details.enabledInfo')"
          col
          reverse
          class="w-full"
        >
          <toggle-field v-model="_resource.enabled" :status="status" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group
          v-slot="{ status }"
          :label="$t('general.allowOnlineBooking')"
          :name="$t('general.allowOnlineBooking')"
          :info="$t('components.resource.edit.details.allowOnlingBookingInfo')"
          col
          reverse
          class="w-full"
        >
          <toggle-field v-model="_resource.allowInternet" :status="status" />
        </o-field-group>
      </div>

      <div class="flex space-x-4 mb-4">
        <o-field-group
          v-slot="{ status }"
          :label="$t('resource.rostered')"
          :name="$t('resource.rostered')"
          :info="$t('components.resource.edit.details.rosteredInfo')"
          col
          reverse
          class="w-full"
        >
          <toggle-field v-model="_resource.resourceRostered" :status="status" />
        </o-field-group>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import {
  OCustomFields,
  OAvatar,
} from '@/components/elements'

import {
  TextField,
  TextAreaField,
  ToggleField,
} from '@/components/fields'

interface Props {
  resource: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:resource', value: Record<string, any>): void
}>()

const _resource = computed({
  get () {
    return props.resource
  },
  set (value) {
    emit('update:resource', value)
  },
})
</script>
